export default __webpack_public_path__ + "static/media/ArrowRightWhite.48431910.svg";